<template>
    <div class="person">
        <div class="condition">
        <div class="item">
                <div class="label">姓名:</div>
                <el-input v-model="conditionData.Name" size="small" placeholder="请输入"></el-input>
            </div>
            <div class="item">
                <div class="label">电话:</div>
                <el-input v-model="conditionData.Phone" size="small" placeholder="请输入"></el-input>
            </div>
            <div class="item">
                <div class="label">所属机构:</div>
                <el-input v-model="conditionData.MechanismName" size="small" placeholder="请输入"></el-input>
            </div>
            <div class="item">
                <div class="label">派驻公司:</div>
                <el-input v-model="conditionData.Company" size="small" placeholder="请输入"></el-input>
            </div>
            <div class="btns">
                <el-button type="primary" size="small" @click="selectData()">查询</el-button>
                <el-button type="" size="small" @click="reset()">重置</el-button>
            </div>
        </div>

        <div class="table">
            <div class="handle">
                <el-button type="" icon="el-icon-refresh-left" size="small" @click="loadingData()">刷新列表</el-button>
                <div class="handle-r">
                    <!-- <el-button type="success" icon="el-icon-download" size="small" @click="downloadExcel()">下载批量新增模板</el-button>
                    <el-upload
                        :action="uploadUrl"
                        Multiple
                        :show-file-list="false"
                        :http-request="importExcel"
                        >
                        <el-button type="success" icon="el-icon-upload" size="small" style="margin:0 10px">导入excel</el-button>
                    </el-upload>
                    <el-button type="primary" icon="el-icon-circle-plus" size="small" @click="addDialogF()">新建</el-button> -->

                    <el-button type="info" icon="el-icon-download" size="small" @click="exportExcel()">导出Excel</el-button>
                </div>
            </div>
            <el-table
                :data="tableData"
                border
                :header-cell-style="tableHeaderColor"
                style="width: 100%">
                <el-table-column
                prop="name"
                label="姓名"
                align="center"
                width="120px"
                >
                
                </el-table-column>
                <el-table-column
                prop="phone"
                label="电话"
                align="center"
                width="160px"
                >
                </el-table-column>
                <el-table-column
                prop="mechanismName"
                label="机构"
                align="center"
                >
                </el-table-column>
                <el-table-column
                prop="company"
                label="派驻公司"
                align="center"
                >
               
                </el-table-column>
                <el-table-column
                prop="district"
                label="地区"
                align="center"
                >
                </el-table-column>
                
                <el-table-column
                prop="appraisalFee"
                label="标准公估费"
                align="center"
                width="160px"
                >
                </el-table-column>
                <el-table-column
                prop="onJob"
                label="是否在职"
                align="center"
                width="120px"
                >
                <template slot-scope="scope">
                    {{scope.row.onJob?'是':'否'}}
                </template>
                </el-table-column>
                <!-- <el-table-column
                prop="pgTs"
                label="创建时间"
                align="center"
                width="100px"
                >
                </el-table-column> -->
                <el-table-column
                fixed="right"
                label="操作"
                width="180px"
                align="center"
                >
                <template slot-scope="scope">
                    <el-button type="text" icon="el-icon-edit" size="mini" @click="editDialog(scope.row)">编辑</el-button>
                    <el-button type="text" icon="el-icon-delete" size="mini" @click="deletePersonPaiZhuTip(scope.row)">删除</el-button>

                    
                </template>
                </el-table-column>
            </el-table>
           

            <div class="page">
                <el-pagination
                @current-change="handleCurrentChange"
                    background
                    layout="prev, pager, next, total"
                    :total="totalCount"
                    :current-page="conditionData.page"
                    :page-size="conditionData.pageSize">
                </el-pagination>
            </div>
        </div>


        <el-dialog :close-on-click-modal="false" :visible.sync="isAddDialog" title="新增" width="600px">
            <div class="dialog">
                <div class="item">
                    <div class="label">
                        姓名:
                    </div>
                    <div class="value">
                        <el-input v-model="addData.name" size="small" placeholder="请输入"></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        电话:
                    </div>
                    <div class="value">
                        <el-input v-model="addData.phone" size="small" placeholder="请输入"></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        所属机构:
                    </div>
                    <div class="value">
                        <el-input v-model="addData.mechanismName" size="small" placeholder="请输入" disabled></el-input>
                        <el-button type="primary"  size="small" @click="isMechanismDialog = true">选择</el-button>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        派驻公司:
                    </div>
                    <div class="value">
                        <el-input v-model="addData.company" size="small" placeholder="请输入"></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        地区:
                    </div>
                    <div class="value">
                        <el-cascader
                        size="small"
                        :options="options"
                        v-model="district"
                        @change="handleAddRegionChange">
                        </el-cascader>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        标准公估费:
                    </div>
                    <div class="value">
                        <el-input v-model="addData.appraisalFee" size="small" placeholder="请输入"></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        是否在职:
                    </div>
                    <div class="value">
                        
                        <el-select v-model="addData.onJob" size="small" placeholder="请选择"  class="citem-input">
                                <el-option
                                v-for="item in isJobList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                                </el-option>
                            </el-select>
                    </div>
                </div>
                <!-- <div class="item">
                    <div class="label">
                        备注:
                    </div>
                    <div class="value">
                        <el-input v-model="addData.identiNumber" size="small" placeholder="请输入" type="textarea"></el-input>
                    </div>
                </div> -->
                <div slot="footer" class="dialog-footer">
                    <el-button @click="isAddDialog = false">取 消</el-button>
                    <el-button type="primary" @click="addPerson">确 定</el-button>
                </div>
            </div>
        </el-dialog>

        <el-dialog :close-on-click-modal="false" :visible.sync="isUpdateDialog" title="编辑" width="600px">
            <div class="dialog">
                <div class="item">
                    <div class="label">
                        姓名:
                    </div>
                    <div class="value">
                        <el-input v-model="updateData.name" size="small" placeholder="请输入"></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        电话:
                    </div>
                    <div class="value">
                        <el-input v-model="updateData.phone" size="small" placeholder="请输入"></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        所属机构:
                    </div>
                    <div class="value">
                        <el-input v-model="updateData.mechanismName" size="small" placeholder="请输入" disabled></el-input>
                        <el-button type="primary"  size="small" @click="isMechanismDialog = true">选择</el-button>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        派驻公司:
                    </div>
                    <div class="value">
                        <el-input v-model="updateData.company" size="small" placeholder="请输入"></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        地区:
                    </div>
                    <div class="value">
                        <el-cascader
                        size="small"
                        :options="options"
                        v-model="district"
                        @change="handleUpdateRegionChange">
                        </el-cascader>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        标准公估费:
                    </div>
                    <div class="value">
                        <el-input v-model="updateData.appraisalFee" size="small" placeholder="请输入"></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        是否在职:
                    </div>
                    <div class="value">
                        
                        <el-select v-model="updateData.onJob" size="small" placeholder="请选择"  class="citem-input">
                                <el-option
                                v-for="item in isJobList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                                </el-option>
                            </el-select>
                    </div>
                </div>
                <!-- <div class="item">
                    <div class="label">
                        备注:
                    </div>
                    <div class="value">
                        <el-input v-model="addData.identiNumber" size="small" placeholder="请输入" type="textarea"></el-input>
                    </div>
                </div> -->
                <div slot="footer" class="dialog-footer">
                    <el-button @click="isUpdateDialog = false">取 消</el-button>
                    <el-button type="primary" @click="updatePerson">确 定</el-button>
                </div>
            </div>
        </el-dialog>
      
        <el-dialog :close-on-click-modal="false" :visible.sync="isMechanismDialog" title="选择机构" width="1000px">
            <div class="condition">
                <div class="item">
                    <div class="label">机构名称:</div>
                    <el-input v-model="conditionDataMechanism.Name" size="small" placeholder="请输入机构名称"></el-input>
                </div>
                <div class="btns">
                    <el-button type="primary" size="small" @click="selectDataMechanism()">查询</el-button>
                    <el-button type="" size="small" @click="resetMechanism()">重置</el-button>
                </div>
            </div>
            <el-table
            ref="multipleTable"
            :data="mechanismList"
            border
            :header-cell-style="tableHeaderColor"
            style="width:100%"
            height="400px"
            >
            <!-- <el-table-column
            type="selection"
            align="center"
            width="55">
            </el-table-column> -->
            <el-table-column
            type="index"
            label="序号"
            width="60"
            align="center"
            >
            </el-table-column>
            <el-table-column
            prop="name"
            label="机构名称"
            align="center"
            >
            </el-table-column>
            <el-table-column
            prop="jianCheng"
            label="分机构简称"
            align="center"
            width="150px"
            >
            </el-table-column>
            <el-table-column
            prop="code"
            label="所在地区"
            align="center"
            >
            <template slot-scope="scope">
                {{scope.row.province}}
                {{scope.row.city}}
                {{scope.row.district}}
            </template>

            </el-table-column>
            <el-table-column
                fixed="right"
                label="操作"
                width="180px"
                align="center"
                >
                <template slot-scope="scope">
                    <el-button type="primary" @click="selectMechanism(scope.row)" icon="el-icon-edit-outline">确 定</el-button>
                </template>
                </el-table-column>
            </el-table>
            <div class="page">
                <el-pagination
                @current-change="handleCurrentChangeMechanism"
                    background
                    layout="prev, pager, next, total"
                    :total="totalCountMechanism"
                    :current-page="conditionDataMechanism.page"
                    :page-size="conditionDataMechanism.pageSize">
                </el-pagination>
            </div>
            <div class="footer" style="margin-top:20px">
                <el-button icon="el-icon-circle-close" @click="isMechanismDialog=false">关 闭</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import api from '../../../api/main'
import { regionData , CodeToText , TextToCode } from "element-china-area-data";
import { auditStatusList } from '../../../assets/selectList/anxin'

export default {
    name: 'person',
    components:{
        
    },
    watch: {
    },
    data () {
        return {
            district:'',
            options:regionData,
            addData:{},
            updateData:{},
            auditStatusList:auditStatusList,
            title:'',
            tableData:[],
            totalCount:0,
            conditionData:{
                 Name:null,
                Phone:null,
                MechanismName:null,
                Company:null,
                page:1,
                pageSize:10,
                MechanismId: null
            },
            isAddDialog:false,
            isUpdateDialog:false,

            mechanismList:[],
            isMechanismDialog:false,
            selectMechanismList:[],
            conditionDataMechanism:{
                page:1,
                pageSize:10,
            },
            totalCountMechanism:0,

            isJobList:[
                {
                    label:'是',
                    value:true
                },{
                    label:'否',
                    value:false
                }
            ],
        }
    },
    created(){
        
    },
    mounted(){
        this.loadingData();
        this.queryMechanism();
    },
    methods:{
        deletePersonPaiZhuTip(row){
            this.$confirm('确认删除, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.deletePersonPaiZhu(row);
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消退出'
                });          
            });
        },
        async deletePersonPaiZhu(row){
            let res = await api.deletePersonPaiZhu(row.id);
            if(res.data.code == '200'){
                this.$message({
                    type: 'success',
                    message: '删除成功'
                });    
                this.loadingData();
            }
        },
        downloadExcel(){
            const elt = document.createElement('a');
            elt.setAttribute('href', 'http://txggpic.oss-cn-shenzhen.aliyuncs.com/20220412/20220412181201rjexe/人员派驻.xlsx');
            elt.style.display = 'none';
            document.body.appendChild(elt);
            elt.click();
        },
        // 导入excel
        async importExcel(file){
            let res = await api.importFreeRecord(file.file,{
                Type:21,
            });
            if(res.data.code == 200){
                this.$message({
                    type: 'success',
                    message: '导入成功'
                });
                this.loadingData();
            }
        },
        addDialogF(){
            this.isAddDialog = true;
            this.district = [];
        },
       async exportExcel(){

           this.conditionData.MechanismId=localStorage.getItem('mechanismid');
            let res = await api.exportPersonPaiZhu({
                "type": 12,
                "Condition": this.conditionData
            },'人员派驻信息');
            console.log(res);


        }
        ,
        selectDataMechanism(){
      
            console.log(this.conditionDataMechanism);
            this.queryMechanism();
        },
        resetMechanism(){
            this.conditionDataMechanism = {
                page:1,
                pageSize:10,
            };
            this.queryMechanism();
        },
        // 机构列表
        async queryMechanism(){
            console.log(this.conditionDataMechanism);
            let res = await api.QueryMechanism(this.conditionDataMechanism);
            this.mechanismList = res.data.data.data;
            this.totalCountMechanism = res.data.data.totalCount;
        },
        // 机构分页
        handleCurrentChangeMechanism(page){
            this.conditionDataMechanism.page = page;
            this.queryMechanism();
        },
        tableHeaderColor ({ row, column, rowIndex, columnIndex }) {
            if (rowIndex === 0) {
                return 'background-color: #F2F2F2;color: #000;'
            }
        },
        async loadingData() {
            let res  = await api.queryPagerPersonPaiZhu(this.conditionData);
            console.log(res);
            this.tableData = res.data.data.data;
            this.totalCount = res.data.data.totalCount;
        },
        selectData(){
            this.conditionData.page = 1;
            this.loadingData();
        },
        reset(){
            this.conditionData = {
                 Name:null,
                Phone:null,
                MechanismName:null,
                Company:null,
                page:1,
                pageSize:10,
            },
            this.loadingData();
        },
        handleCurrentChange(page){
            this.conditionData.page = page;
            this.loadingData();
        },
        // 选择地区
        handleAddRegionChange(codeArray){
            if(codeArray[0]){
                this.addData.district = CodeToText[codeArray[0]]
            }
            if(codeArray[1]){
                this.addData.district = this.addData.district+','+CodeToText[codeArray[1]]
            }
            if(codeArray[2]){
                this.addData.district = this.addData.district+','+CodeToText[codeArray[2]]
            }
        },
        handleUpdateRegionChange(codeArray){
            if(codeArray[0]){
                this.updateData.district = CodeToText[codeArray[0]]
            }
            if(codeArray[1]){
                this.updateData.district = this.updateData.district+','+CodeToText[codeArray[1]]
            }
            if(codeArray[2]){
                this.updateData.district = this.updateData.district+','+CodeToText[codeArray[2]]
            }
        },
        // 选择机构
        selectMechanism(row){
            if(this.isAddDialog){
                this.addData.mechanismId = row.id;
                this.addData.mechanismName = row.jianCheng;
            }else{
                this.updateData.mechanismId = row.id;
                this.updateData.mechanismName = row.jianCheng;
            }
            
            this.isMechanismDialog = false;
        },
        
        async addPerson(){
            this.addData.appraisalFee = parseFloat(this.addData.appraisalFee);
            let res = await api.addPersonPaiZhu(this.addData);
            if(res.data.code == '200'){
                this.$message({
                    type: 'success',
                    message: '新增成功!'
                });
                this.isAddDialog = false;
                this.addData = {};
                this.district = [];
                this.loadingData();
            }
        },

        async updatePerson(){
            this.updateData.appraisalFee = parseFloat(this.updateData.appraisalFee);
            let res = await api.updatePersonPaiZhu(this.updateData);
            if(res.data.code == '200'){
                this.$message({
                    type: 'success',
                    message: '编辑成功!'
                });
                this.isUpdateDialog = false;
                this.loadingData();
            }
        },

        // 编辑弹框
        editDialog(row){
            this.isUpdateDialog = true;
            this.updateData = row;
            let districtText = this.updateData.district.split(',')
            console.log(districtText);
            if(districtText[2]){
                this.district = [TextToCode[districtText[0]].code,TextToCode[districtText[0]][districtText[1]].code,TextToCode[districtText[0]][districtText[1]][districtText[2]].code];
                return;
            }
            if(districtText[1]){
                this.district = [TextToCode[districtText[0]].code,TextToCode[districtText[0]][districtText[1]].code ];
            }
            this.$forceUpdate();
        },
    }
    
}
</script>

<style lang="scss" scoped>
    .condition{
        background-color: #ffffff;
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        border-radius: 5px;
        padding: 10px;
        font-size: 14px;
        .item{
            display: flex;
            align-items: center;
            margin-right: 20px;
            padding: 5px;
            .label{
                min-width: 110px;
            }
        }
        .btns{
            margin-left: 20px;
        }
    }
    .table{
        margin-top: 10px;
        background-color: #ffffff;
        padding: 15px;
        .tb-red{
            color:red;
        }
        .handle{
            width: 100%;
            display: flex;
            justify-content: space-between;
            padding-bottom: 15px;
            align-items: center;
            font-size: 20px;
            .handle-r{
                display: flex;
            }
        }
        .page{
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-top: 16px;
            .el-pagination{
                margin-left: -10px;
            }
        }
    }

    .dialog{
        padding-top: 20px;
        height: 100%;
        .handle{
            width: 100%;
            display: flex;
            justify-content: space-between;
            padding-bottom: 15px;
            align-items: center;
            font-size: 20px;
            
        }
        
        .item{
            font-size: 14px;
            padding:10px 15px;
            display: flex;
            align-items: center;
            .label{
                margin-bottom: 5px;
                width: 150px;
            }
            .value{
                width: 215px;
                display: flex;
            }
        }
        
        .dialog-footer{
            display: flex;
            padding:10px 15px;
            flex-direction: row-reverse;
            .el-button{
                margin-left: 20px;
            }
        }
    }
    /deep/.el-input.is-disabled .el-input__inner{
        color: #606266;
    }
</style>
